export enum ScheduledRequestStatus {
    created = 'created',
    failed = 'failed',
    scheduled = 'scheduled',
}
